export default "__VITE_ASSET__BU4je_TY__"